import '../css/style.scss';
import '../css/style_radio.scss';
// import UAParser from 'https://cdn.jsdelivr.net/npm/ua-parser-js@0/dist/ua-parser.min.js'
// ツイートボタン押下時にテキストを動的に変更してツイート
function tweet() {
    closeModal();
    // ツイート内容
    var text = (document.getElementsByClassName('js_input-text')[0]).value;
    text += 'さんがチケットを発券しました！\n';
    // ハッシュタグ
    var hashtags = '海月とうみ初配信チケット発券所';
    // リンクURL
    var url = 'https://toumi-ticket.netlify.app/\n';
    // ウェブインテントのURL
    var tweetUrl = 'https://twitter.com/intent/tweet?text=' +
        encodeURIComponent(text) +
        '&hashtags=' +
        encodeURIComponent(hashtags) +
        '&url=' +
        encodeURIComponent(url);
    // 新しいウィンドウを開く
    window.open(tweetUrl, '_blank');
}
function isiPhone() {
    // // User-Agent文字列を取得
    // const userAgent = navigator.userAgent
    // // iPhoneの場合、User-Agent文字列に"iPhone"が含まれます
    // return /iPhone/i.test(userAgent)
    var ua = new UAParser();
    if (ua.getOS().name === 'iOS') {
        return true;
    }
    return false;
}
var charPosition = /** @class */ (function () {
    // コンストラクタ
    function charPosition(angle, transPosX, transPosY, drawPosX, drawPosY) {
        this.angle = angle;
        this.transPosX = transPosX;
        this.transPosY = transPosY;
        this.drawPosX = drawPosX;
        this.drawPosY = drawPosY;
    }
    return charPosition;
}());
var kotobagaki = '詞書：';
function openModal() {
    // document.getElementById('modal').classList.remove('hidden')
    // document.getElementById('modal-overlay').classList.remove('hidden')
    var modal_iphone = document.getElementById('modal_iphone');
    var modal_other = document.getElementById('modal_other');
    var modalOverlay = document.getElementById('modal-overlay');
    if (isiPhone()) {
        modal_iphone.classList.remove('hidden');
    }
    else {
        modal_other.classList.remove('hidden');
    }
    modalOverlay.classList.remove('hidden');
}
// モーダルを閉じる関数
function closeModal() {
    // document.getElementById('modal').classList.add('hidden')
    // document.getElementById('modal-overlay').classList.add('hidden')
    var modal_iphone = document.getElementById('modal_iphone');
    var modal_other = document.getElementById('modal_other');
    var modalOverlay = document.getElementById('modal-overlay');
    modal_iphone.classList.add('hidden');
    modal_other.classList.add('hidden');
    modalOverlay.classList.add('hidden');
}
function buttonAction() {
    openModal();
    if (isiPhone()) {
        convertToImage();
    }
    else {
        downloadCardImage();
    }
}
function downloadCardImage() {
    var canvas = document.getElementById('canvas');
    if (canvas) {
        //アンカータグを作成
        var a = document.createElement('a');
        //canvasをJPEG変換し、そのBase64文字列をhrefへセット
        a.href = canvas.toDataURL('image/png');
        //ダウンロード時のファイル名を指定
        var date = new Date();
        var filename = "toumi-ticket_".concat(('0' + date.getFullYear()).slice(-2)).concat(('0' +
            (date.getMonth() + 1)).slice(-2)).concat(('0' + date.getDate()).slice(-2), ".png");
        a.download = filename;
        //クリックイベントを発生させる
        a.click();
    }
}
/*
 * @author phi_jp
 */
window.onload = function () {
    drawCanvas();
};
function fontSetting(context, mode) {
    // ★デバッグ用
    var inputElement = document.getElementsByClassName('js_input-font-size')[0];
    var value = inputElement.value;
    // ★デバッグ用
    if (context !== null) {
        // テキストの色を設定
        context.fillStyle = '#F3F0F2';
        context.font = '600 ' + value + 'px IBM Plex Sans JP';
    }
}
function getCheckedFont() {
    return 'IBM Plex Sans JP';
}
function getTicketId() {
    var color1RadioButton = document.getElementById('color1');
    if (color1RadioButton.checked) {
        return 'ticket1';
    }
    var color2RadioButton = document.getElementById('color2');
    if (color2RadioButton.checked) {
        return 'ticket2';
    }
    var color3RadioButton = document.getElementById('color3');
    if (color3RadioButton.checked) {
        return 'ticket3';
    }
    var color5RadioButton = document.getElementById('color5');
    if (color5RadioButton.checked) {
        return 'ticket5';
    }
    var color6RadioButton = document.getElementById('color6');
    if (color6RadioButton.checked) {
        return 'ticket6';
    }
    return 'ticket4';
}
function drawCanvas() {
    changeCanvasSize();
    var canvas = document.getElementById('canvas');
    var context = canvas.getContext('2d');
    if (!context) {
        return;
    }
    var displayElem = document.getElementsByClassName('js_display')[0];
    displayElem.style.fontFamily = getCheckedFont();
    var name = document.getElementsByClassName('js_input-text')[0];
    var text = name.value;
    // 画像を読み込み、Canvasに描画
    var img = new Image();
    var imgE = document.getElementById(getTicketId());
    img.src = imgE.src;
    img.onload = function () {
        context.drawImage(img, 0, 0); // 画像をCanvasの左上に描画
        tategaki(context, '', text, '', '', canvas.width, canvas.height);
    };
}
var tategaki = function (context, title, text, note1, note2, x, y) {
    // 本文出力
    {
        // ★デバッグ用
        var inputElement1 = document.getElementsByClassName('js_input-pos-x')[0];
        var value1 = inputElement1.value;
        var inputElement2 = document.getElementsByClassName('js_input-pos-y')[0];
        var value2 = inputElement2.value;
        // ★デバッグ用
        var textList = text.split('\n');
        // フォント設定
        fontSetting(context, 1);
        context.fillText(textList[0], Number(value1), Number(value2));
    }
};
function changeCanvasSize() {
    var canvas = document.getElementById('canvas');
    if (!canvas) {
        return;
    }
    var canvasSize = getCanvasSize();
    canvas.setAttribute('width', canvasSize.width.toString());
    canvas.setAttribute('height', canvasSize.height.toString());
}
function getCanvasSize() {
    // デフォルト値を返す
    return { width: 2400, height: 1080 };
}
function registerButtonEvent(selector, callback) {
    var button = document.querySelector(selector);
    button.addEventListener('click', callback);
}
function convertToImage() {
    var canvas = document.getElementById('canvas');
    var context = canvas.getContext('2d');
    if (!context)
        return;
    // ここでcanvasに描画したり、別の方法でcanvasを準備する
    // 例：canvasに図形やテキストを描画する
    // ctx.fillRect(0, 0, canvas.width, canvas.height);
    // context.fillText('Hello, world!', 10, 50)
    // 仮の画像ソースを設定し、onloadイベントを発火させる
    // これにより、onloadイベントハンドラが実行されてcanvasに描画されます
    // const image = new Image()
    // image.src = 'https://toumi-ticket.netlify.app/image/ticket1.png' // 画像のURLを設定
    // const canvas = document.getElementById('canvas') as HTMLCanvasElement
    if (canvas) {
        //   //アンカータグを作成
        var a = document.createElement('a');
        //   //canvasをJPEG変換し、そのBase64文字列をhrefへセット
        a.href = canvas.toDataURL('image/png');
        //   //ダウンロード時のファイル名を指定
        //   const date = new Date()
        //   const year = `${date.getFullYear()}`.slice(-2)
        //   const filename = `toumi-ticket_${('0' + date.getFullYear()).slice(-2)}${(
        //     '0' +
        //     (date.getMonth() + 1)
        //   ).slice(-2)}${('0' + date.getDate()).slice(-2)}.png`
        //   a.download = filename
        //   //クリックイベントを発生させる
        //   a.click()
        // }
        // image.onload = function () {
        //   context.drawImage(image, 0, 0)
        //ダウンロード時のファイル名を指定
        var date = new Date();
        //   // CanvasからDataURLを取得し、それをimg要素のsrcに設定して画像を表示する
        var canvasImage = document.getElementById('canvasImage');
        if (!canvasImage)
            return;
        canvasImage.src = canvas.toDataURL('image/png');
        // }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    registerButtonEvent('.js_button', buttonAction);
    registerButtonEvent('.js_closeModal', closeModal);
    // js_tweetButtonクラスを持つ要素を全て取得
    var tweetButtons = document.querySelectorAll('.js_tweetButton');
    // 各要素にクリックイベントリスナーを設定
    tweetButtons.forEach(function (button) {
        button.addEventListener('click', tweet);
    });
    var radioButtons = document.querySelectorAll('input[name="tab_item"]');
    radioButtons.forEach(function (radioButton) {
        radioButton.addEventListener('change', function (event) {
            drawCanvas();
        });
    });
    var textareas = document.querySelectorAll('.js_input-text');
    textareas.forEach(function (areas) {
        areas.addEventListener('input', function () {
            drawCanvas();
        });
    });
});
